import {Box, Flex, Info, Text, Title} from 'exsportia-components'
import {useFormikContext} from 'formik'
import {FC, ReactElement, useCallback, useEffect} from 'react'

import {SignModalTitleWithInfo} from '../../components/sign-modal-title-with-info/sign-modal-title-with-info'
import {GoogleIcon} from '../../icons'
import {ForgotPasswordForm} from '../../services/auth/forms/forgot-password-form'
import {Button} from '../../ui/components/button/button'
import {Input} from '../../ui/components/input/input'
import {signInWithGoogle} from '../../utils/firebase'
import {useLocale} from '../../utils/i18n'
import {useModalActions} from '../../utils/modals'

const PhoneIcon: FC = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z' />
  </svg>
)

export const CheckEmailStep: FC<{
  isLoading?: boolean
  setModalTitle?: (title: ReactElement | string) => void
  formModalDescription?: string
  phoneLoginAction?: () => void
}> = ({
  isLoading,
  setModalTitle,
  formModalDescription,
  phoneLoginAction,
}) => {
  const {l} = useLocale()
  const {openModal, closeAllModals} = useModalActions()
  const {handleSubmit} = useFormikContext()
  const handleOpenForgotPasswordModal = useCallback(
    () =>
      openModal({
        component: <ForgotPasswordForm />,
        title: l('forgotPassword'),
        footerConfig: {
          disabled: true,
        },
      }),
    [openModal, l],
  )

  useEffect(() => {
    if (setModalTitle) {
      setModalTitle(<SignModalTitleWithInfo />)
    }
  }, [l, setModalTitle])

  const handleContinueWithGoogle = useCallback(async () => {
    const user = await signInWithGoogle()
    if (user) {
      console.log('Logged in successfully:', user)
      closeAllModals()
    }
  }, [])

  return (
    <Box pb={'24px'}>
      <Flex mb='8px'>
        <Title
          text={l('checkIfHaveAcc')}
          styleType='h2'
        />
      </Flex>
      <Flex mb='16px'>
        <Text text={l('enter_your_email', {caseAction: 'capitalize'})} />
      </Flex>
      <Input
        id={'email'}
        placeholder={l('email')}
      />
      {formModalDescription && <Info text={formModalDescription} settings={{text: {croppedLines: 7}}} />}
      <Button
        type='flat'
        onClick={handleOpenForgotPasswordModal}
        disabled={isLoading}
      >
        {l('forgotPassword')}
      </Button>
      <Box mt={'16px'}>
        <Button
          // @ts-ignore
          onClick={handleSubmit}
          isLoading={isLoading}
          disabled={isLoading}
        >
          {l('continue')}
        </Button>
      </Box>
      <Box mt={'16px'}>
        <Button
          type={'secondary'}
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          onClick={handleContinueWithGoogle}
          disabled={isLoading}
        >
          <Flex
            alignItems={'center'}
            justifyContent={'center'}
          >
            <GoogleIcon />
            <Box ml={'8px'}>{l('continueWithGoogle')}</Box>
          </Flex>
        </Button>
      </Box>
      {phoneLoginAction && (
        <Box mt={'16px'}>
          <Button
            type={'secondary'}
            onClick={phoneLoginAction}
            disabled={isLoading}
          >
            <Flex
              alignItems={'center'}
              justifyContent={'center'}
            >
              <PhoneIcon />
              <Box ml={'8px'}>{l('continueWithPhone', {defaultMessage: 'Continue with Phone'})}</Box>
            </Flex>
          </Button>
        </Box>
      )}
    </Box>
  )
}
